import { useContext } from 'react';
import { Button, Grid, Typography, FormControlLabel, Checkbox, MenuItem } from '@mui/material';
import { Form, Field, useFormikContext } from 'formik';
import { TextField } from 'formik-mui';
import * as yup from 'yup';
import { Link, useLocation } from 'react-router-dom';
import { warehouseSchema } from '../WarehouseDetailsContext';
import { applicationContext } from 'helpers/services';
import { DueIstance } from 'helpers/enums';

let WarehouseForm = () => {
    let router = useLocation();
    let appService = useContext(applicationContext);

    let isNew = router.pathname.includes('/addnew');
    let title = isNew ? 'New warehouse' : `Edit warehouse`;

    type Warehouse = yup.InferType<typeof warehouseSchema>;
    let form = useFormikContext<Warehouse>();

    return (
        <Form>
            <Grid container alignItems='center'>
                <Grid item xs>
                    <Typography gutterBottom variant="h4">{title}</Typography>
                </Grid>
                <Grid item>
                    <Button
                        variant="outlined"
                        color="primary"
                        size="medium"
                        component={Link}
                        to={'/admin/warehouse'}
                    >
                        Cancel
                    </Button>
                </Grid>
                <Grid item>
                    <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                    >
                        Save
                    </Button>
                </Grid>
            </Grid>
            <Grid container alignItems='center'>
                <Grid item xs>
                    <Field
                        component={TextField}
                        name="code"
                        label="Code"
                        disabled={isNew === false}
                        fullWidth
                        margin="dense"
                        size='small'
                    />
                </Grid>
                <Grid item xs>
                    <Field
                        component={TextField}
                        name="erpVendorCode"
                        label="Vendor Code"
                        fullWidth
                        margin="dense"
                        size='small'
                        select
                        disabled={isNew === false}
                    >
                        {appService.referenceData.ERPVendorCodes.map((erpVendorCode) =>
                            <MenuItem key={erpVendorCode.key} value={erpVendorCode.key}>{erpVendorCode.value}</MenuItem>
                        )}
                    </Field>
                </Grid>
                <Grid item>
                    <FormControlLabel
                        label="Is virtual"
                        name="isVirtual"
                        value={form.values.isVirtual}
                        checked={form.values.isVirtual}
                        onChange={(e: any) => form.setFieldValue('isVirtual', e.target.checked)}
                        control={<Field type="checkbox" name="isVirtual" component={Checkbox} />}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Field
                        component={TextField}
                        label="Warehouse list"
                        name="warehouseList"
                        fullWidth
                        margin="dense"
                        size='small'
                        select
                        SelectProps={{
                            multiple: true
                        }}
                    >
                        {appService.referenceData.Warehouse.map((warehouse) =>
                            <MenuItem key={warehouse.key} value={warehouse.key}>{warehouse.value}</MenuItem>
                        )}
                    </Field>
                </Grid>
            </Grid>
        </Form>
    );
}

export default WarehouseForm;